export default __webpack_public_path__ + "static/media/Moments.9cfa8a46.png";